var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebar8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 18,
    height: 18,
    transform: "translate(20 106)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_18",
    "data-name": "Mask Group 18",
    transform: "translate(-20 -106)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(20 105.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M9.209,1.252a.563.563,0,0,0-.418,0L2.077,3.938,9,6.706l6.923-2.769Zm7.666,3.517L9.563,7.694v8.912l7.313-2.925V4.77ZM8.438,16.607V7.693L1.125,4.769v8.913l7.313,2.925ZM8.373.207a1.687,1.687,0,0,1,1.253,0l8.02,3.208A.563.563,0,0,1,18,3.938v9.745a1.125,1.125,0,0,1-.708,1.044L9.209,17.96a.563.563,0,0,1-.419,0L.709,14.726A1.125,1.125,0,0,1,0,13.682V3.938a.562.562,0,0,1,.353-.522Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar8);
export default __webpack_public_path__ + "static/media/sidebar8.1e8cc0edefa328ae92b2018df3d79356.svg";
export { ForwardRef as ReactComponent };